export const SERVER_URL = process.env.REACT_APP_API_SERVER_URL;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_CLIENT_API_KEY = process.env.REACT_APP_GOOGLE_CLIENT_API_KEY;
export const GOOGLE_CLIENT_CALLBACK_URL = process.env.REACT_APP_GOOGLE_CALLBACK_RUL;
export const SERVER_UPLOAD_URL = process.env.REACT_APP_API_SERVER_URL + '/upload';
export const RESOURCE_URL = process.env.REACT_APP_RESOURCE_URL ?? process.env.REACT_APP_API_SERVER_URL;
export const SERVER_MODE = process.env.REACT_APP_ENV_MODE;

// for editor
export const TEMP_IMAGE_UPLOAD_API_URL = `${SERVER_URL}/api/fo/common/files/upload`;

export const GRID_LAYOUT = 10;

export const INIT_PAGESIZE = 15;

export const B2C_PML_GID = 80;

export enum MSG {
  SUCCESS_SAVE = '저장을 완료하였습니다.',
  SUCCESS_REGISTER = '해당 정보가 등록되었습니다.',
  SUCCESS_MAIL_SEND = '메일이 발송 되었습니다.',
  SUCCESS_SMS_SEND = '문자가 발송 되었습니다.',
  SUCCESS_DELETE = '삭제를 완료하였습니다.',
  SUCCESS_COPY = '복사를 완료하였습니다.',
  SUCCESS_REGISTER_USER = '사용자 정보를 등록 하였습니다. 등록시 사용한 이메일로 인증해주세요.',
  SUCCESS_ACTIVATE_USER = '사용자 계정이 활성화 되었습니다. 로그인 후 이용해 주세요.',
  SUCCESS_RESET_PASSWORD = '새로운 비밀번호가 등록 되었습니다. 로그인 후 이용해 주세요.',
  SUCCESS_INSERT = '등록을 완료하였습니다.',
  WARNING_EXPERT_CHANGE = '변경된 내역이 있습니다. 업데이트 정보는 Contact Point가 등록한 전문가 정보에서 수정해주세요.',
  SUCCESS_RESTORE = '일정이 복원 완료하였습니다.',
  ERROR_IDPW = '아이디 또는 비밀번호가 일치하지 않습니다.',
  ERROR_EMAIL = '사용중인 이메일입니다..',
  ERROR_DUPLICATED_LOGIN = '다시 로그인 시도를 해주세요.',
  ERROR_COMMON = '오류가 발생했습니다. 다시 시도해주세요.',
  ERROR_FILESIZE = '업로드 가능 용량 초과.',
  ERROR_LOGIN_BANNED = '사용자 계정이 잠겨 있습니다. 관리자에게 문의 바랍니다.',
  ERROR_LOGIN_ACTIVATED = '사용자 계정이 활성화 되어 있지 않습니다. 이메일을 확인 바랍니다.',
  ERROR_FORM_VALIDATION = '필수항목을 확인하여 주세요.',
  ERROR_DUPLICATED_USER = '이미 등록된 사용자 입니다. 로그인 후 이용해 주세요.',
  ERROR_ACTIVATE_USER = '활성화 가능한 계정이 아닙니다. 로그인 후 이용해 주세요.',
  ERROR_ACCOUNT_CLOSE = '회계 마감된 내역이 있어 수정이 불가 합니다.',
  ERROR_DUP_EXCEPTPRICE = '예상매출은 동일월에 강의구분을 기준으로 하나만 등록 가능합니다.',
  ERROR_DUP_SCHEDULE = '대기 스케줄이 존재하여 확정 상태로 변경이 불가 합니다.',
}

export type PROJECT_WORK_TYPE = 'confirm' | 'consult' | 'drop' | undefined;
export type MY_PROJECT_GROUP_TYPE = 'none' | 'b2b1' | 'b2b2' | 'b2b3' | 'b2b5' | undefined;


